import { MagnifyingGlassIcon, XCircleIcon } from '@heroicons/react/24/solid';
import { handleFormatingAddress, isEmptyData } from '../../../../utils/helper';
import CurrentLocation from '../CurrentLocation';
import RecentAddress from '../RecentAddress';
import SavedAddress from '../SavedAddress';
import Map from '../Map';
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';
import { GOOGLE_MAP_STATUS } from '../../../../utils/constants';
import { LoaderIcon, NotFoundSearchIcon, PinPointIcon } from '../../../../utils/svg';
import { useDispatch } from 'react-redux';
import { setUser } from '../../../../store/reducers/user';

const Result = (props) => {
	const { data = [], status, loading, onClose } = props;
	const dispatch = useDispatch();

	const handleClick = async (data = null) => {
		if (isEmptyData(data?.place_id)) return;
		await getGeocode({ placeId: data?.place_id }).then((results) => {
			const result = results[0];
			const { lat, lng } = getLatLng(result);
			const formated = handleFormatingAddress({
				lat,
				lng,
				formatted_address: result?.formatted_address || '',
				address_components: result?.address_components || {},
				detail: result?.address_detail ?? null,
			});
			dispatch(
				setUser({
					addressName: null,
					address: formated?.address,
					latitude: Number(formated?.lat),
					longitude: Number(formated?.lng),
					country: formated?.country,
					state: formated?.state,
					city: formated?.city,
					village: formated?.village,
					district: formated?.district,
					postalCode: formated?.postalCode ?? '',
					detail: null,
				}),
			);
		});
		onClose();
	};

	return (
		<div className='min-h-96'>
			{loading && (
				<div className='flex justify-center items-center w-full py-4'>
					<LoaderIcon />
				</div>
			)}
			{data?.map((item, index) => {
				return (
					<div key={item.place_id} className='[&:not(:last-child)]:border-b border-solid border-[var(--pin-ball)] p-2.5 flex items-center gap-2.5' onClick={() => handleClick(item)}>
						<PinPointIcon className='fill-gray-500 w-4 h-4 shrink-0' />
						<div className='space-y-0.5'>
							<p className='text-[var(--dark-gray)] text-sm font-semibold'>{item.structured_formatting.main_text}</p>
							{item.structured_formatting.secondary_text && <p className='text-[var(--dark-gray)] text-xxs'>{item.structured_formatting.secondary_text}</p>}
						</div>
					</div>
				);
			})}
			{status === GOOGLE_MAP_STATUS.ZERO_RESULTS && (
				<div className='py-7 px-4 flex flex-col items-center'>
					<NotFoundSearchIcon className='w-56 h-auto fill-[var(--rose-violet)]' />
					<p className='text-[var(--dark-gray)] font-semibold text-sm px-6 mb-1.5 text-center'>Hmm, tidak ada lokasi yang ditemukan</p>
					<p className='text-[var(--dark-gray)] text-xxs text-center px-14'>Kami tidak dapat menemukan apa yang Anda cari. Bagaimana kalau mencoba sesuatu yang lain??</p>
				</div>
			)}
		</div>
	);
};

const Search = (props) => {
	const {
		ready: isAutocompleteReady,
		value: search,
		suggestions: { data, status, loading },
		setValue: setSearch,
		clearSuggestions,
	} = usePlacesAutocomplete({
		debounce: 1000,
		requestOptions: { types: [] },
	});

  const handleChange = (value) => {
	setSearch(value, false);
	if (value.trim().length >= 3) {
		setSearch(value);
	}
  };

	const handleCloseSearch = () => {
		console.log('handleCloseSearch');
		setSearch('');
		clearSuggestions();
	};

	return (
		<>
			<div className='flex items-center rounded-full border border-solid border-gray-200 p-2 gap-3'>
				<MagnifyingGlassIcon className={`h-4 w-4 text-gray-600`} strokeWidth={3} />
				<input placeholder='Mau cari alamat apa?' value={search} onChange={(e) => handleChange(e.target.value)} className='flex-auto w-full m-0 bg-transparent border-none outline-none text-xs font-normal' disabled={!isAutocompleteReady} />
				{!isEmptyData(search) && <XCircleIcon onClick={() => handleCloseSearch()} className='h-4 w-auto text-gray-500' />}
			</div>
			{!isEmptyData(search) ? (
				<>
					<Result {...{ data, status, loading, ...props }} />
				</>
			) : (
				<>
					<Map />
					<CurrentLocation {...props} />
					<div className='h-2 w-full bg-light-house mb-4'></div>
					<SavedAddress {...props} />
					<RecentAddress {...props} />
				</>
			)}
		</>
	);
};

export default Search;
